import { useI18n } from "../i18n";
import { useNavigate } from "react-router-dom";
import { usePaypalReturn } from "../hooks/usePaypalReturn";
import { HomeHeader, HomeHero } from "../components/HomeSections";
import { useAuth } from "../context/AuthContext";
import { TrialCard } from "../components/TrialCard";
import { PlansSection } from "../components/PlansSection";
import { SubscriptionCard } from "../components/SubscriptionCard";
import { LoyaltyCard } from "../components/LoyaltyCard";

export default function Home() {
  const { t } = useI18n();
  const { user, loading, login, logout, refresh } = useAuth();
  const navigate = useNavigate();
  const subActive = user?.subscription?.active;
  const showPlans = user && !subActive && !user.trial?.active;

  usePaypalReturn(refresh);

  return (
    <div className="ghost-root" data-testid="home-page">
      <div className="scanlines" />
      <div className="max-w-5xl mx-auto px-4 py-10 flex flex-col gap-12 relative z-10">
        <HomeHeader user={user} onLogout={logout} />
        <HomeHero user={user} loading={loading} onStart={() => navigate("/session")} onLogin={login} />

        <section className="grid gap-4" data-testid="trial-section">
          {subActive ? <SubscriptionCard /> : <TrialCard user={user} />}
          {showPlans && (
            <p className="font-mono text-sm text-amber border border-[#7A5500] p-4" data-testid="trial-ended-banner">
              {user.trial && t("trialEndedBanner")}{t("chooseSub")}
            </p>
          )}
        </section>

        {showPlans && <PlansSection />}

        {user && !user.trial?.active && <LoyaltyCard />}

        <p className="text-center text-xs text-subtle font-mono">{t("footer")}</p>
      </div>
    </div>
  );
}
